module.exports = __webpack_public_path__ + "07_long_black.5611d652.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/07_long_black.png
// module id = 6UM/
// module chunks = 0